<template>
    <ul class="list-group">
        <li class="list-group-item main">
          {{parent.title}}
          <router-link :to="'/page/' + parent.slug + '/create'" class="float-right mt-1" id="parent-add"  v-if="user.editor || user.admin">
            <i class="fa fa-plus"></i>
          </router-link>
        </li>
        <page-menu-item v-for="page in parent.children" :key="page.slug" :page="page" :parentSlug="parent.slug"
                        level="1"
                        :actual-uri="uri"/>
    </ul>
</template>

<script>
  import PageMenuItem from './PageMenuItem.vue';

  export default {
    name: 'PageMenu',
    props: {
      parent: Object,
      uri: String,
      user: Object
    },
    components: {
      PageMenuItem
    }
  };
</script>

<style scoped>
    #parent-add {
        width: auto;
        height: auto;
        padding: 0;
        color: white;
    }
</style>
